// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f1acd0c8","455":"a5181d94","977":"95689915"}[chunkId] + ".chunk.js";
};